<template>
  <v-btn
    :color="color"
    :variant="variant"
    :size="size"
    :disabled="disabled"
    :loading="loading"
    :block="block"
    :rounded="rounded"
    :outlined="outlined"
    :text="text"
    :dark="dark"
    :light="light"
    :icon="icon"
    :fab="fab"
    :elevation="elevation"
    :ripple="ripple"
    :class="customClass"
    :style="customStyle"
    @click="handleClick"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <v-icon v-if="prependIcon" left>{{ prependIcon }}</v-icon>
    <slot>{{ label }}</slot>
    <v-icon v-if="appendIcon" right>{{ appendIcon }}</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'DefaultButton',
  inheritAttrs: false,
  props: {
    // Podstawowe właściwości
    label: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'primary'
    },
    variant: {
      type: String,
      default: 'contained',
      validator: value => ['contained', 'outlined', 'text'].includes(value)
    },
    size: {
      type: String,
      default: 'default',
      validator: value => ['x-small', 'small', 'default', 'large', 'x-large'].includes(value)
    },

    // Stany
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },

    // Wygląd
    block: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    text: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    },
    light: {
      type: Boolean,
      default: false
    },
    icon: {
      type: Boolean,
      default: false
    },
    fab: {
      type: Boolean,
      default: false
    },
    elevation: {
      type: [Number, String],
      default: undefined
    },
    ripple: {
      type: [Boolean, Object],
      default: true
    },

    // Ikony
    prependIcon: {
      type: String,
      default: ''
    },
    appendIcon: {
      type: String,
      default: ''
    },

    // Dodatkowe style
    customClass: {
      type: [String, Array, Object],
      default: ''
    },
    customStyle: {
      type: [String, Object],
      default: ''
    }
  },

  computed: {
    computedVariant() {
      if (this.outlined) return 'outlined'
      if (this.text) return 'text'
      return this.variant
    }
  },

  methods: {
    handleClick(event) {
      if (!this.disabled && !this.loading) {
        this.$emit('click', event)
      }
    }
  }
}
</script>

<style scoped>
/* Dodatkowe style dla DefaultButton */
.v-btn {
  text-transform: none; /* Usuwa automatyczne wielkie litery */
}

/* Niestandardowe warianty kolorów */
.v-btn.success {
  background-color: #4caf50 !important;
  color: white !important;
}

.v-btn.warning {
  background-color: #ff9800 !important;
  color: white !important;
}

.v-btn.danger {
  background-color: #f44336 !important;
  color: white !important;
}

.v-btn.info {
  background-color: #2196f3 !important;
  color: white !important;
}

/* Hover effects */
.v-btn:hover {
  transform: translateY(-1px);
  transition: transform 0.2s ease;
}

.v-btn:active {
  transform: translateY(0);
}
</style>
